import React, { useState, useEffect } from "react";
import { db } from "../firebase"; // افترض أنك قمت بإعداد Firebase
import { collection, getDocs, query, where, orderBy, limit } from "firebase/firestore";
import { useNavigate } from "react-router-dom"; // استخدام useNavigate بدلاً من useHistory

const collectionsList = [
  "TouristAttractions",
  "bookings",
  "halalMarkets",
  "hotels",
  "mosques",
  "offers",
  "publicPaths",
  "residences",
  "restaurants",
  "touristGuides",
  "touristResorts",
  "transportOffers",
  "users",
];

const translateCollectionName = (collectionName) => {
  switch (collectionName) {
    case "TouristAttractions":
      return "المعالم السياحية";
    case "bookings":
      return "الحجوزات";
    case "halalMarkets":
      return "الأسواق الحلال";
    case "hotels":
      return "الفنادق";
    case "mosques":
      return "المساجد";
    case "offers":
      return "العروض";
    case "publicPaths":
      return "المسارات العامة";
    case "residences":
      return "الإقامات";
    case "restaurants":
      return "المطاعم";
    case "touristGuides":
      return "المرشدين السياحيين";
    case "touristResorts":
      return "المنتجعات السياحية";
    case "transportOffers":
      return "عروض النقل";
    case "users":
      return "المستخدمين";
    default:
      return collectionName;
  }
};

const GeneralSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // استخدام useNavigate للتوجيه

  const handleSearch = async () => {
    if (!searchTerm) return;
    setLoading(true);
    const allResults = [];

    for (const collectionName of collectionsList) {
      const collectionRef = collection(db, collectionName);

      if (collectionName === "transportOffers") {
        // البحث في transportOffers
        const snapshot = await getDocs(collectionRef);
        snapshot.forEach((doc) => {
          const data = doc.data();
          const matches = Object.values(data).some((value) =>
            typeof value === "string" && value.includes(searchTerm)
          );

          if (matches) {
            allResults.push({
              id: doc.id,
              ...data,
              collection: collectionName,
            });
          }
        });
      } else {
        // البحث في باقي المجموعات
        const q = query(
          collectionRef,
          where("name", ">=", searchTerm),
          where("name", "<=", searchTerm + "\uf8ff"),
          orderBy("name"),
          limit(10)
        );

        const snapshot = await getDocs(q);
        snapshot.forEach((doc) => {
          allResults.push({
            id: doc.id,
            ...doc.data(),
            collection: collectionName,
          });
        });
      }
    }

    setResults(allResults);
    setLoading(false);
  };

  // استدعاء البحث كلما تغير النص في مربع البحث
  useEffect(() => {
    if (searchTerm.length > 2) {
      handleSearch();
    } else {
      setResults([]);
    }
  }, [searchTerm]);

  // التوجيه إلى أول نتيجة
  const handleNavigate = () => {
    if (results.length > 0) {
      const firstResult = results[0];
      navigate(`/OffersPage/${firstResult.id}`); // استخدام navigate بدلاً من history.push
    }
  };

  return (
    <div className="relative flex flex-col items-center p-6">
      <div className="w-full max-w-md flex justify-center items-center">
        <input
          type="text"
          placeholder="ابحث عن :رحلة , فندق, مطعم ..."
          className="w-max px-6 py-4 border text-xl border-gray-300 rounded-full focus:outline-none focus:ring focus:ring-green-400"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          className="mx-4 px-6 py-4 w-full text-xl bg-green-500 text-white rounded-full hover:bg-green-600"
          onClick={handleNavigate} // التوجيه إلى أول نتيجة
          disabled={loading}
        >
          {loading ? "جاري البحث..." : "بحث"}
        </button>
      </div>

      {/* قائمة النتائج المنسدلة تحت مربع البحث */}
      {results.length > 0 && (
        <div className="absolute mt-32 w-full max-w-md bg-white shadow-lg rounded-lg z-10">
          {results.map((result, index) => (
            <div
              key={index}
              className="p-4 mb-3 border-b border-gray-300 cursor-pointer hover:bg-gray-100"
              onClick={() => navigate(`/OffersPage/${result.id}`)}
            >
              <h2 className="text-lg font-bold text-gray-700">
                {result.name || "بدون اسم"}
              </h2>
              <p className="text-sm text-gray-500">
                مصدر: {translateCollectionName(result.collection)}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* عرض الرسالة أثناء تحميل البيانات */}
      <div className=" w-full max-w-2xl flex justify-center items-center">
        {loading && <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-600"></div>}
        {!loading && results.length === 0 && searchTerm && (
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-600"></div>
        )}
      </div>
    </div>
  );
};

export default GeneralSearch;
